import { Component, computed, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomDialogModalComponent } from '@shared/components/modals/custom-dialog-modal/custom-dialog-modal.component';
import type { ActionButton } from '@shared/components/modals/custom-modal/models/action-button.models';
import { AppPromoService } from '@shared/services/app-promo/app-promo.service';
import { MobileAppLinksService } from '@core/auth/services/mobile-app-links.service';
import { PlatformUtilityService } from '@shared/services/platform/platform-utility.service';

@Component({
  selector: 'app-app-promo-modal',
  templateUrl: './app-promo-modal.component.html',
  styleUrls: ['./app-promo-modal.component.scss'],
  standalone: true,
  imports: [CustomDialogModalComponent, TranslateModule]
})
export class AppPromoModalComponent {
  private readonly modalController = inject(ModalController);
  private readonly appPromoService = inject(AppPromoService);
  private readonly translate = inject(TranslateService);
  private readonly mobileAppLinksService = inject(MobileAppLinksService);
  private readonly platformUtility = inject(PlatformUtilityService);

  private readonly appLinks = computed(() => this.mobileAppLinksService.getMobileAppLinks());

  readonly showAppStoreBadge = computed(
    () =>
      (this.appLinks()?.appStore.isActive ?? false) &&
      this.platformUtility.isWebPlatform() &&
      !this.platformUtility.isAndroidWeb()
  );
  readonly showPlayStoreBadge = computed(
    () =>
      (this.appLinks()?.playStore.isActive ?? false) &&
      this.platformUtility.isWebPlatform() &&
      !this.platformUtility.isIOSWeb()
  );

  readonly actionButtons = computed<ActionButton[]>(() => [
    {
      text: this.translate.instant('appPromo.popup.continueInBrowser'),
      action: 'continue',
      color: 'primary'
    }
  ]);

  openAppStore(): void {
    this.appPromoService.openAppStoreLink();
  }

  openPlayStore(): void {
    this.appPromoService.openPlayStoreLink();
  }

  onContinue(): void {
    this.modalController.dismiss().then();
  }
}
